import { render, staticRenderFns } from "./clientCom.vue?vue&type=template&id=61261c89&"
import script from "./clientCom.vue?vue&type=script&lang=js&"
export * from "./clientCom.vue?vue&type=script&lang=js&"
import style0 from "./clientCom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports